import { NavLink, Text, ThemeIcon } from '@mantine/core';
import { IconLanguage, IconStack3, IconWorld } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const data = [
  {
    icon: <IconStack3 />,
    label: 'Quota',
    path: '/console/quota',
    subMenu: [
      {
        icon: <IconStack3 />,
        label: 'Overview',
        path: '/console/quota/overview',
      },
      {
        icon: <IconStack3 />,
        label: 'Managed',
        path: '/console/quota/managed/client',
      },
    ],
  },
  {
    icon: <IconLanguage />,
    label: 'Language',
    path: '/console/language',
    subMenu: [],
  },
  {
    icon: <IconWorld />,
    label: 'Locale',
    path: '/console/locale',
    subMenu: [],
  },
];
const NavConsoleMenu = () => {
  const navigate = useNavigate();

  const onClick = (path: string, subMenu: unknown[] = []) => {
    if (subMenu.length <= 0) {
      navigate(path);
    }
  };

  return (
    <>
      {data.map((link) => {
        return (
          <NavLink
            key={link.path}
            label={
              <Text size="md" c="brand">
                {link.label}
              </Text>
            }
            leftSection={<ThemeIcon variant="light">{link.icon}</ThemeIcon>}
            color="gray"
            childrenOffset={28}
            className="rounded-md focus:bg-gray-200"
            onClick={() => onClick(link.path, link.subMenu)}
          >
            {link.subMenu.length > 0 &&
              link.subMenu.map((child) => (
                <NavLink
                  key={child.label}
                  label={
                    <Text size="md" c="brand">
                      {child.label}
                    </Text>
                  }
                  color="gray"
                  className="rounded-md focus:bg-gray-200"
                  onClick={() => onClick(child.path)}
                />
              ))}
          </NavLink>
        );
      })}
    </>
  );
};

export default NavConsoleMenu;
